import { FC, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import MultiSelect from '@/components/common/Select/Select';
import CityIcon from '@/public/icons/team/filter/city.svg';
import FormatIcon from '@/public/icons/team/filter/format.svg';
import TypeIcon from '@/public/icons/team/filter/time.svg';
import SearchIcon from '@/public/icons/team/search.svg';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/buttons/Button';

interface Option {
  label: string;
  value: string;
}

interface VacanciesFilterProps {
  citiesOptions: Option[];
  typesOptions: Option[];
  formatsOptions: Option[];
  selectedCities: string[];
  selectedTypes: string[];
  selectedFormats: string[];
}

export const VacanciesFilter: FC<VacanciesFilterProps> = ({
  citiesOptions,
  typesOptions,
  formatsOptions,
  selectedCities,
  selectedTypes,
  selectedFormats,
}) => {
  const router = useRouter();
  const { t } = useTranslation('common');
  const buttonText = t('vacanciesFilterBtn');
  const cityText = t('city');
  const formatText = t('teamFormat');
  const typeText = t('teamType');
  const [cities, setCities] = useState<string[]>(selectedCities);
  const [types, setTypes] = useState<string[]>(selectedTypes);
  const [formats, setFormats] = useState<string[]>(selectedFormats);

  useEffect(() => setCities(selectedCities), [selectedCities]);
  useEffect(() => setTypes(selectedTypes), [selectedTypes]);
  useEffect(() => setFormats(selectedFormats), [selectedFormats]);

  const applyFilters = () => {
    const query: Record<string, string | string[]> = {};

    if (cities.length) query.city = cities;
    if (types.length) query.type = types;
    if (formats.length) query.format = formats;

    router.push(
      {
        pathname: router.pathname,
        query: { ...query, page: '1' },
      },
      undefined,
      { shallow: true },
    );
  };

  return (
    <div className="vacancies-filter al md:align-center mb-8 md:mb-[32px] md:flex">
      <div className="vacancies-filter__selects md:align-center mb-4 md:mb-0 md:flex md:w-full">
        <MultiSelect
          options={citiesOptions}
          placeholder={cityText}
          icon={<CityIcon />}
          selected={cities}
          setSelected={setCities}
        />

        <MultiSelect
          options={typesOptions}
          placeholder={typeText}
          icon={<TypeIcon />}
          selected={types}
          setSelected={setTypes}
        />

        <MultiSelect
          options={formatsOptions}
          placeholder={formatText}
          icon={<FormatIcon />}
          selected={formats}
          setSelected={setFormats}
        />
      </div>
      <Button
        onClick={applyFilters}
        className="vacancies-filter__apply-btn md:h-[58px] md:w-[58px] lg:w-fit"
      >
        <span className="vacancies-filter__apply-btn-text">{buttonText}</span>
        <SearchIcon />
      </Button>
    </div>
  );
};
